import MaterialReactTable from 'material-react-table'
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { useState, useEffect } from "react";
import {Button, Box} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ReactTablePopUpMultiSelect({
    title,
    columns,
    data,
    onClose,
    onRowSubmit,
    onCSVExport,
    onPDFExport,
    enableExportToolbar = false,
    enableTableSearch = true,
    isLoading = true,
    closeButtonLabel = 'CLOSE',
    defaultPageSize = 5,
}) {
//    console.log(JSON.stringify(data)+"data ReactTablePopUpMultiSelect");
    const [tableColumns, setTableColumns] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: defaultPageSize,
    });
    useEffect(() => {
        // console.log('Useeffect rendered');
        const tableColumns = columns.map(col => {

            let cellAlign = col.align || 'left';
            let columnProperties = {
                accessorKey: col.fieldName,
                header: col.headerName,
                size:col.size
            };

            if (col.headerName === 'ROW_ACTIONS') {
                columnProperties = {
                    ...columnProperties,
                    header: 'Action',
                    Header: <span style={col.headerStyle}>Action</span>,
                    Cell: ({renderedCellValue,row}) => {
                        const isChecked = row.original.isChecked;
                        const isDisabled =row.original.isDisabled;
                        // console.log(isChecked+"isCheckedAction ")
                        return (
                            <span>
                                {(
                                    <input type="checkbox" onChange={(evnt)=>(onRowSubmit(renderedCellValue,evnt))} checked={isChecked || false} name="isChecked" disabled={isDisabled}/>
                                )}
                            </span>
                        );
                    }
                }
                
            } 
            else {

                if (col.headerStyle) {
                    columnProperties = {
                        ...columnProperties,
                        Header: <span style={col.headerStyle}>{col.headerName}</span>
                    };
                }

                columnProperties = {
                    ...columnProperties,
                    Cell: ({renderedCellValue}) => {

                        return (
                            <div style={{textAlign: cellAlign}}>
                                {col.dataStyle ? <span style={col.dataStyle}>{renderedCellValue}</span> : renderedCellValue}
                            </div>
                        
                        );
                    }
                };
            }

            return columnProperties;
        });

        setTableColumns(tableColumns);

    },[columns, onRowSubmit]);

    return (
        <div style={{paddingTop: "10px", paddingBottom: "10px"}}>
            <h1 style={{fontSize: '22px', color: 'darkblue', fontWeight: 'bold', display:'none'}}>{title}</h1>
            <MaterialReactTable
                columns={tableColumns}
                data={data}
                enablePinning
                enableStickyHeader
                enableColumnResizing
                // enableColumnOrdering
                // enableColumnDragging
                columnResizeMode="onEnd" 
                enableColumnActions={false}
                enableColumnFilters={enableTableSearch}
                enableGlobalFilter={enableTableSearch}
                enableFilters={enableTableSearch}
                enableToolbarInternalActions={enableTableSearch || enableExportToolbar}
                positionGlobalFilter="right"
                muiSearchTextFieldProps={{
                    placeholder: 'Search...',
                    size: 'small',
                    variant: 'outlined',
                    sx: { minWidth: '220px', backgroundColor: '#fff' },
                }}
                enablePagination={true}
                enableSorting={true}
                enableBottomToolbar={true}
                enableTopToolbar={enableTableSearch || enableExportToolbar}
                muiTableBodyRowProps={{hover: true}}
                enableDensityToggle={enableTableSearch || enableExportToolbar}
                state={{isLoading: isLoading, pagination}}
                onPaginationChange={setPagination}
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10, 15, 20, 25, 50, 100],
                    SelectProps: {
                        MenuProps: {
                            disablePortal: true,
                            sx: { zIndex: 3000 },
                        },
                    },
                }}
                muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                      borderRadius: '0',
                      border: '1px solid #000000',
                    },
                  }}
                  muiTableBodyProps={{
                    sx: (theme) => ({
                      '& tr:nth-of-type(odd)': {
                        backgroundColor:'#bcbfc4',
                      },
                    }),
                  }}
                muiTableHeadCellProps={{
                    align: 'center',
                    sx: {
                      fontWeight: 700,
                      fontSize: '15px',
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #305870 0%, #186098 48%, #0090D8 100%)',
                      backgroundColor: '#186098',
                      color: '#ffffff',
                    },
                  }}
                initialState={
                    {
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: defaultPageSize},
                        columnPinning: {  left:['id']}
                    }
                }
                renderTopToolbarCustomActions={
                    ({table}) => {
                        if (enableExportToolbar) {
                            return (
                                <span>
                                    <Button color="primary" onClick={onClose}  variant="contained">{closeButtonLabel}</Button>
                                    <Button color="primary" onClick={onCSVExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">Excel</Button>
                                    &nbsp;&nbsp;
                                    <Button color="primary" onClick={onPDFExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">PDF</Button>
                                </span>
                            );
                        } else {
                            return (<> <Button color="primary" onClick={onClose}  variant="contained">CLOSE</Button></>);
                        }
                    }
                }
            />
        </div>
    );
}

export default ReactTablePopUpMultiSelect;

